import { ActiveUserProducer } from 'types/types.type';
import { Organization } from 'types/organization.type';
import React, { ReactFragment } from 'react';
import { BaseActiveProducer } from './BaseActiveProducer';
import { CARRIER_USER_NO_SUBMISSIONS } from '../../constants';

// This is for carrier or audit users who should not be producers so everything is empty
export class CarrierRepActiveProducer extends BaseActiveProducer {
    getAvailableProducers(): Organization[] {
        return [];
    }
    getCreateSubmissionSubHeader(assignedProducer: Organization, doSelectProducer: () => void): ReactFragment {
        return '';
    }
    getEffectiveActiveProducer(): Organization | undefined {
        return undefined;
    }
    async fetchAvailableAgents(): Promise<void> {
        return new Promise<void>((res) => {
            res();
        });
    }

    getProducer(): Organization {
        return {} as Organization;
    }

    getId(): string | undefined {
        return undefined;
    }

    validateAssignedProducer(assignedProducer: Organization): Organization | undefined {
        return undefined;
    }

    getTemplateQualifier(fileType: string, availableQualifiers: string[] | undefined): string {
        return '';
    }

    getSubmissionDetailsSubHeader(assignedProducer: Organization): ReactFragment | string {
        return '';
    }

    getNoSubmissionsText(assignedProducer: Organization): React.ReactFragment {
        return CARRIER_USER_NO_SUBMISSIONS;
    }
}
